
const baseUrl =
  process.env.NODE_ENV === "development"
    ? "http://localhost:4002"
    : window.location.href.split(".")[3] === "staging"
    ? "https://atci.lkm-securitylearninghub.staging.accenture.com/securitylearninghubstage-apis" // Staging
    : "https://atci.lkm-securitylearninghub.accenture.com/securitylearninghub-apis"; // Production

export default baseUrl;